"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var __1 = require("../");
function useToken() {
    var _a, _b;
    var auth = (0, react_1.useContext)(__1.AuthenticatorContext);
    return (_b = (_a = auth.user) === null || _a === void 0 ? void 0 : _a.getSignInUserSession()) === null || _b === void 0 ? void 0 : _b.getAccessToken().getJwtToken();
}
exports.default = useToken;
//# sourceMappingURL=useToken.js.map